import React from "react";
import ProjectCard from "./ProjectCard";

const ProjectsList = ({ projects, onCardClicked, onDeleteClicked, onRestoreClicked }) => {
  return (
    <div className="projects-list">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          onCardClicked={onCardClicked}
          onDeleteClicked={onDeleteClicked}
          onRestoreClicked={onRestoreClicked}
          project={project}
        />
      ))}
    </div>
  );
};

export default ProjectsList;
